import { render, staticRenderFns } from "./CorrectAnswerForm.vue?vue&type=template&id=72a9736b&scoped=true&"
import script from "./CorrectAnswerForm.vue?vue&type=script&lang=js&"
export * from "./CorrectAnswerForm.vue?vue&type=script&lang=js&"
import style0 from "./CorrectAnswerForm.vue?vue&type=style&index=0&id=72a9736b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72a9736b",
  null
  
)

export default component.exports